import React from "react";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { FileUpload } from "primereact/fileupload";
import { ProgressSpinner } from "primereact/progressspinner";
import config from "../../../config";

// Component for editing a paper type
const EditPaperTypeForm = ({
  visible,
  onHide,
  editedPaperType,
  syllabusOptions,
  mediumOptions,
  gradeOptions,
  subjectOptions,
  onInputChange,
  handleFileUpload,
  handleClearImage,
  fileUploadRef,
  filePreview,
  saveEditedPaperType,
  loading,
}) => {
  return (
    <Dialog
      header="Edit Paper Type"
      visible={visible}
      onHide={onHide}
      style={{ width: "900px", maxHeight: "700px" }}
    >
      <div className="p-fluid">
        <div style={{ display: "flex" }}>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="syllabusId">Syllabus</label>
            <Dropdown
              id="syllabusId"
              name="syllabusId"
              value={editedPaperType.syllabusId}
              options={syllabusOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px", marginRight: "20px" }}
            />
          </div>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="mediumId">Medium</label>
            <Dropdown
              id="mediumId"
              name="mediumId"
              value={editedPaperType.mediumId}
              options={mediumOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="gradeId">Grade</label>
            <Dropdown
              id="gradeId"
              name="gradeId"
              value={editedPaperType.gradeId}
              options={gradeOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px", marginRight: "20px" }}
            />
          </div>
          <div
            className="p-field"
            style={{ marginBottom: "20px", width: "50%" }}
          >
            <label htmlFor="subjectId">Subject</label>
            <Dropdown
              id="subjectId"
              name="subjectId"
              value={editedPaperType.subjectId}
              options={subjectOptions}
              onChange={onInputChange}
              optionLabel="label"
              optionValue="value"
              style={{ marginTop: "10px" }}
            />
          </div>
        </div>
        <div className="p-field" style={{ marginBottom: "20px" }}>
          <label htmlFor="paperTypeName">Paper Type</label>
          <InputText
            id="paperTypeName"
            name="paperTypeName"
            value={editedPaperType.paperTypeName}
            onChange={onInputChange}
            style={{ marginTop: "10px", marginRight: "10px" }}
          />
        </div>
        <div className="p-field" style={{ marginBottom: "20px" }}>
          <label htmlFor="image">Image</label>
          <FileUpload
            ref={fileUploadRef}
            name="image"
            accept="image/*"
            chooseLabel="Upload"
            uploadLabel="Upload"
            mode="basic"
            customUpload
            onSelect={handleFileUpload}
            style={{ marginTop: "10px" }}
          />
          {filePreview && (
            <>
              <img
                src={filePreview}
                alt="Uploaded"
                style={{ maxWidth: "150px", marginTop: "10px" }}
              />
              <i
                className="pi pi-times-circle"
                onClick={handleClearImage}
                style={{
                  cursor: "pointer",
                  marginLeft: "10px",
                  verticalAlign: "middle",
                  fontSize: "1rem",
                  color: "#bb2124",
                }}
              ></i>
            </>
          )}
          {!filePreview && editedPaperType.image && (
            <>
              <img
                src={`${config.apiUrl}/uploads/${editedPaperType.image}`}
                alt="ExistingImage"
                style={{ maxWidth: "150px", marginTop: "10px" }}
              />
              <div
                style={{
                  maxWidth: "150px",
                  marginTop: "10px",
                  color: "#198754",
                }}
              >
                <b>
                  <center>{editedPaperType.image}</center>
                </b>
              </div>
            </>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="visibility">Visibility</label>
          <br></br>
          <RadioButton
            id="visibility"
            name="visibility"
            value={true}
            onChange={onInputChange}
            checked={editedPaperType.visibility === true}
            style={{ marginTop: "10px" }}
          />{" "}
          Yes &nbsp;
          <RadioButton
            id="visibility"
            name="visibility"
            value={false}
            onChange={onInputChange}
            checked={editedPaperType.visibility === false}
            style={{ marginTop: "10px" }}
          />{" "}
          No
        </div>
      </div>
      <div
        className="p-dialog-footer"
        style={{
          marginTop: "20px",
          marginBottom: "-20px",
          marginRight: "-24px",
        }}
      >
        <Button label="Cancel" onClick={onHide} severity="danger" outlined />
        <Button
          label={
            loading ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                Saving...&nbsp;&nbsp;
                <ProgressSpinner
                  style={{
                    width: "20px",
                    height: "20px",
                    marginRight: "5px",
                  }}
                />
              </div>
            ) : (
              "Save"
            )
          }
          onClick={saveEditedPaperType}
          severity="success"
          outlined
          disabled={loading}
        />
      </div>
    </Dialog>
  );
};

export default EditPaperTypeForm;
